// EADT detail getLinkedData loads the part number, then reads
// partNumber.ManufacturerID. db.once returns null when that record is missing,
// which throws `reading 'ManufacturerID'` and aborts the detail route.
// The same block also reads partNumber.Number, partNumber.Description,
// manufacturer.Name, and manufacturer.ID with no null check.

function lookupId(value) {
    if (typeof value !== "string" || value.length === 0) return null;
    return value;
}

export async function loadEadtLinkedData(db, pageItem) {
    const partNumberId = lookupId(pageItem?.PartNumberID);
    if (!partNumberId) return {};

    const partNumber = await db.once(`Database/PartNumbers/${partNumberId}`);
    if (partNumber == null) return {};

    const manufacturerId = lookupId(partNumber.ManufacturerID);
    const manufacturer = manufacturerId
        ? await db.once(`Database/Manufacturers/${manufacturerId}`)
        : null;

    return {
        PartNumber: partNumber.Number ?? null,
        Manufacturer: manufacturer?.Name ?? null,
        ManufacturerID: manufacturer?.ID ?? null,
        Name: partNumber.Description ?? null,
    };
}
